export function getSidebarPin_getters(state) {
    return state.sidebarPin
}
